
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBipolar_transistor01 as ObiBipolar_transistor01Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-bipolar_transistor-01.js';
 
 
 

 
 export const ObiBipolar_transistor01 = createComponent({
   react: React,
   tagName: 'obi-bipolar_transistor-01',
   elementClass: ObiBipolar_transistor01Element,
   events: {
     
   }
  });
 
 